'use client';

import React, { forwardRef } from 'react';
import { cn } from '../../utils/cn';

export interface DialogTitleProps extends React.HTMLAttributes<HTMLHeadingElement> {
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}

export const DialogTitle = forwardRef<HTMLHeadingElement, DialogTitleProps>(
  ({ children, className, as: Component = 'h2', ...props }, ref) => {
    return (
      <Component
        ref={ref}
        className={cn('text-lg font-semibold text-velux-black', className)}
        {...props}
      >
        {children}
      </Component>
    );
  }
);

DialogTitle.displayName = 'DialogTitle';
